import communityLogo from "../assets/logo/community-logo.svg";
import fullLogo from "../assets/logo/full-logo.svg";
import logo from "../assets/logo/logo.svg";

export const LOGOCONSTANT = {
  communityLogo,
  fullLogo,
  logo,
};
